import { render } from "./AboutUsSliderTwo.vue?vue&type=template&id=75f584e0&scoped=true"
import script from "./AboutUsSliderTwo.vue?vue&type=script&lang=js"
export * from "./AboutUsSliderTwo.vue?vue&type=script&lang=js"

import "./AboutUsSliderTwo.vue?vue&type=style&index=0&id=75f584e0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-75f584e0"

export default script